const COLORS = ["ffd9a5", "c8ecfd", "bff0c9", "d9cefb", "fdc8c8"];
const CONFIG = {
  baseURL: "https://eu.ui-avatars.com/api/",
  fontSize: "0.4",
  background: "random"
};

export function getRandomValueFrom(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function createPlaceholderProfilePicture({ name, last }) {
  if (!name) {
    return "";
  }

  const nameLetter = Array.from(name)[0];
  const background = getRandomValueFrom(COLORS) || CONFIG.background;
  const letters = last ? `${nameLetter}+${Array.from(last)[0]}` : nameLetter;

  return `${CONFIG.baseURL}?font-size=${CONFIG.fontSize}&name=${letters}&background=${background}`;
}
